import { Item } from 'components/CollabItem/Item'
import { DeleteButton } from './DeleteButton'
import { LayerChange } from '../../providers/LayerChangesProvider/types'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'

interface Props {
  trackedChange: LayerChange
}

export const DeleteTrackedChangeControl = observer(({ trackedChange }: Props) => {
  const docStore = useDocStore()
  const { canRejectChanges } = docStore.trackedChangesStore

  const handleDelete = () => docStore.trackedChangesStore.reject(trackedChange.uuid)

  return (
    <Item.Control tooltipTitle={!canRejectChanges ? 'You do not have access to delete' : undefined}>
      <DeleteButton onPress={handleDelete} isDisabled={!canRejectChanges} />
    </Item.Control>
  )
})
